import { render, staticRenderFns } from "./total-slots-modal.vue?vue&type=template&id=6fa8491d&"
import script from "./total-slots-modal.vue?vue&type=script&lang=js&"
export * from "./total-slots-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports